import {Stack, Typography} from "@mui/material";
import AdmsIdentifierDisplay from "./AdmsIdentifierDisplay";
import {MarkdownSection} from "../utils/landingPageSections";
import {isEmpty} from "../../config/commonFunctions";
import {keys} from "../../config/nameSpacesKeys";
import {useState} from "react";

export default function MsLanguageResourceDisplay(props) {
  const [mappings] = useState(props.mappings);
  const [msLanguageResource] = useState(props.msLanguageResource);

  const {defaultLanguage, topLabel, normalizeBreaks} = props;

  function getLabel(key, defaultValue) {
    const returnValue = mappings[key] || defaultValue;
    if (!returnValue) {
      return key;
    }
    return returnValue;
  }

  if (!msLanguageResource) return null;

  return (
    <Stack sx={{pt: 1, pb: 2}} spacing={1}>
      {topLabel && (
        <Typography variant="h4" gutterBottom noWrap sx={{pt: 1}}>
          {topLabel}
        </Typography>
      )}

      {!isEmpty(msLanguageResource.description.getValue(defaultLanguage)) && (
        <MarkdownSection
          field={msLanguageResource.description}
          defaultLanguage={defaultLanguage}
          getLabel={getLabel}
          normalizeBreaks={normalizeBreaks}
          labelKey={keys.description}
          fallbackLabel="description"
        />
      )}

      {msLanguageResource.title &&
        !isEmpty(msLanguageResource.title.getValue(defaultLanguage)) && (
        <div>
          <Typography variant="body2" className="key">
            {getLabel(keys.title, "title")}
          </Typography>
          <Typography variant="body1">
            {msLanguageResource.title.getValue(defaultLanguage)}
          </Typography>
        </div>
      )}

      <Stack sx={{pt: 1}} spacing={1}>
        <AdmsIdentifierDisplay
          defaultLanguage={defaultLanguage}
          mappings={mappings}
          admsIdentifierList={msLanguageResource.admsList}
        />
      </Stack>
    </Stack>
  );
}
